<template>
  <div class="realEstate">
    <div class="edit-area">
      <h2 class="normal">学区范围</h2>

      <div class="normal">{{ location_name }}</div>

      <div class="edit-area-content">
        <el-button @click="lnglatToDots" type="primary">一键恢复</el-button>
        <el-button @click="addCircle" type="primary">另起一个圈</el-button>
        <el-button @click="switchCircle" type="primary">切换编辑圈</el-button>

        <div class="normal">
          行政区:<input
            type="text"
            @keydown.enter="districtSearch"
            v-model="district"
          />
        </div>

        <button @click="upToDb" class="up">上传数据库</button>
        <div class="normal" style="margin-top: 30px;">
          <p>起始点移动</p>
          <div>
            <el-button type="primary" @click="startBack">后</el-button>
            <el-button type="primary" @click="startForward">前</el-button>
          </div>
        </div>
        <div class="normal">喜欢数: {{ praise_count || 0 }}</div>
        <div>
          <input
            type="text"
            v-model="praise_count1"
            @keydown.enter="addPraise"
          />
          <button @click="addPraise">修改喜欢数</button>
        </div>

        <div class="normal">
          <input type="text" v-model="imageLayerId" />
          <button @click="drawLimitArea">加载辅助图</button>
        </div>
      </div>
    </div>

    <div id="school_container" :style="mapHeight">
      <el-amap-search-box
        class="search-box"
        :search-option="searchOption"
        :on-search-result="onSearchResult"
      >
      </el-amap-search-box>
      <el-button class="query-box" type="primary" @click="getNearschool"
        >查看附近学区</el-button
      >
      <el-amap
        class="amap-box"
        vid="real_map"
        ref="real_map"
        :zoom="zoom"
        :center="center"
        :amap-manager="amapManager"
        :plugin="plugin"
        :events="events"
      >
        <el-amap-polyline
          editable="false"
          v-for="(item, index) in dots"
          :key="'circle' + index"
          :path="item"
          strokeColor="blue"
          strokeWeight="2"
        ></el-amap-polyline>

        <el-amap-marker
          v-for="(marker, index) in markerLists"
          :vid="'school_marker' + index"
          :position="marker.position"
          :content="marker.content"
          :key="'school_marker' + index"
          :events="markerEvents"
          :draggable="true"
        ></el-amap-marker>

        <div v-for="(k, p) in nearbySchoolList" :key="'o' + p">
          <div v-if="k.visible">
            <el-amap-polyline
              editable="false"
              v-for="(item, index) in k"
              :key="'circle2' + index"
              :path="item"
              strokeColor="black"
              strokeWeight="2"
            ></el-amap-polyline>
          </div>
        </div>
        <el-amap-marker
          :vid="'real_search_marker' + index"
          v-for="(marker, index) in markers"
          :key="index"
          :position="[marker.lng, marker.lat]"
        ></el-amap-marker>
        <el-amap-marker
          vid="center_marker"
          :position="center"
          v-if="location_center.length > 0"
          icon="./../../static/images/marker1.png"
        ></el-amap-marker>

        <span v-for="(posList, iindex) in lnglat" :key="'posList' + iindex">
          <el-amap-marker
            :vid="'lnglat_marker' + index + '|posList' + iindex"
            v-for="(pos, index) in posList"
            :key="index"
            :position="pos.split('|')"
            :events="lnglatMarkerEvents"
            :icon="
              index === 0
                ? './../../static/images/marker.png'
                : './../../static/images/marker.png'
            "
            :draggable="true"
            :offset="[-16, -27]"
          ></el-amap-marker>
        </span>
        <div
          v-for="(posList, iiindex) in schollLnglat"
          :key="'posiist' + iiindex"
        >
          <div v-if="posList.visible">
            <span
              v-for="(posList, iindex) in posList"
              :key="'scholl' + iindex + '|posiist' + iiindex"
            >
              <el-amap-marker
                :vid="
                  'lnglat_marker' +
                  index +
                  '|scholl' +
                  iindex +
                  '|posiist' +
                  iiindex
                "
                v-for="(pos, index) in posList"
                :key="'schollmarker' + index"
                :position="pos.split('|')"
                :draggable="true"
                :events="allMarkerEvents"
                :offset="[-16, -27]"
              ></el-amap-marker>
            </span>
          </div>
        </div>
      </el-amap>
    </div>
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
export default {
  data() {
    return {
      color: [
        "green",
        "blue",
        "green",
        "red",
        "yellow",
        "red",
        "green",
        "red",
        "yellow",
      ],
      getMarker: false,
      startDotStep: 3,
      location_name: "",
      location_id: "",
      dots: [],
      nearbySchoolList: [], //附近学区点位

      lnglat: [],
      schollLnglat: [],
      markerLists: [], //附近学区标签
      location_size: "",
      location_type: "商场",
      school_type: "小学",
      private_public: "公办",
      mapHeight: {},
      schoolCenter: "",
      searchOption: {
        city: "杭州",
        citylimit: true,
      },
      zoom: 15,
      center: [120.051238, 30.228232],
      location_center: [],
      amapManager,

      plugin: [
        {
          //地图类型，卫星地图和普通地图
          pName: "MapType",
          defaultType: 0,
        },
      ],
      markers: [],

      lnglatMarkerEvents: {
        rightclick: (e) => {
          console.log("右点击经纬度坐标");
          let that = this;
          let temp = e.target.w.vid.split("|");
          let index = temp[0].replace("lnglat_marker", "");
          let iindex = temp[1].replace("posList", "");
          that.dots[iindex].splice(index, 1);
          that.lnglat[iindex].splice(index, 1);
        },
        click: (e) => {
          let that = this;
          let temp = e.target.w.vid.split("|");
          console.log(temp);
          let index = temp[0].replace("lnglat_marker", "");
          let iindex = temp[1].replace("posList", "");
          that.dots[iindex].push(that.lnglat[iindex][index].split("|"));
        },
        dragging: (e) => {
          let that = this;
          let temp = e.target.w.vid.split("|");
          let index = temp[0].replace("lnglat_marker", "");
          let iindex = temp[1].replace("posList", "");
          let dot = [e.lnglat.lng, e.lnglat.lat];
          if (index == 0) {
            that.dots[iindex].splice(that.dots[iindex].length - 1, 1, dot);
          }
          that.dots[iindex].splice(index, 1, dot);
          that.lnglat[iindex].splice(index, 1, dot.join("|"));
        },
      },
      events: {
        rightclick: (e) => {
          console.log("右点击地图");
          let that = this;
          let dot = [e.lnglat.lng, e.lnglat.lat];
          if (that.lnglat.length === 0) {
            that.dots.unshift([]);
            that.lnglat.unshift([]);
          }
          that.dots[0].push(dot);
          that.lnglat[0].push(dot.join("|"));
        },
      },
      markerEvents: {
        click: (e) => {
          let that = this;
          const index = that.nearbySchoolList.findIndex(
            (m) => m.content === e.target.De.content
          );
          if (index !== -1) {
            that.nearbySchoolList[index].visible =
              !that.nearbySchoolList[index].visible;
            that.schollLnglat[index].visible =
              !that.schollLnglat[index].visible;
          }
          console.log("左点击经纬度坐标", that.nearbySchoolList[index].visible);
        },
      },
      allMarkerEvents: {
        click: (e) => {
          let that = this;
          let temp = e.target.w.vid.split("|");
          let index = temp[0].replace("lnglat_marker", "");
          let iindex = temp[1].replace("scholl", "");
          let iiindex = temp[2].replace("posiist", "");
          console.log(index);
          console.log(
            "左点击经纬度坐标",
            that.schollLnglat[iiindex][iindex][index].split("|")
          );
          that.dots[iindex].push(
            that.schollLnglat[iiindex][iindex][index].split("|")
          );

          // that.dots[0].push(dot);
          that.lnglat[0].push(that.schollLnglat[iiindex][iindex][index]);

          // that.dots.push(index)
          // that.lnglat.push(index)
        },
      },
      district: "",

      praise_count: "",
      praise_count1: "",
      locMap: {
        杭州: "WpLocationModel",
        苏州: "SzLocationModel",
      },

      imageLayerId: "",
    };
  },
  created() {
    let height = window.innerHeight + "px";
    console.log(height);
    this.mapHeight.height = height;
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "login") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      delete origin.mapHeight;
      delete origin.events;
      delete origin.lnglatMarkerEvents;
      delete origin.markerEvents;
      delete origin.allMarkerEvents;
      Object.assign(this.$data, origin);
      this.init();
    }
    this.$route.meta.isBack = false;
  },
  methods: {
    handleMarkerClick(e) {
      console.log("点击标记", this.color);
    },
    init() {
      let that = this;

      let obj = that.$route.params;
      that.searchOption.city = that.$store.state.Counter.city;
      console.log("obj", obj);
      if (obj.id) {
        that.$axios
          .get(that.$url_prefix + "queryOneById", {
            params: {
              id: obj.id,
              db: that.locMap[that.$store.state.Counter.city],
            },
          })
          .then(function (res) {
            console.log(res);
            if (!res.data.success) {
              alert("没有此地段");
              return false;
            }
            that.location_name = res.data.data.location_name;
            that.location_id = res.data.data.id;
            that.praise_count = res.data.data.praise_count;
            if (res.data.data.dots) {
              if (res.data.data.dots.indexOf("-") > -1) {
                that.lnglat.push(res.data.data.dots.split("-"));
                let dots = res.data.data.dots.split("-").map((x) => {
                  return x.split("|");
                });
                dots.push(dots[0]);
                if (res.data.data.location_type === "学校") {
                  that.center = res.data.data.lnglat.split("-")[0].split("|");
                  that.location_center = res.data.data.lnglat
                    .split("-")[0]
                    .split("|");
                } else {
                  that.center = dots[0];
                }
                that.dots.push(dots);
              } else {
                that.lnglat = JSON.parse(res.data.data.dots);
                if (that.lnglat[that.lnglat.length - 1].length === 0) {
                  that.lnglat.pop();
                }
                that.dots = JSON.parse(JSON.stringify(that.lnglat)).map((x) => {
                  for (let i = 0; i < x.length; i++) {
                    x[i] = x[i].split("|");
                  }
                  x.push(x[0]);
                  return x;
                });
                if (res.data.data.location_type === "学校") {
                  that.center = res.data.data.lnglat.split("-")[0].split("|");
                  that.location_center = res.data.data.lnglat
                    .split("-")[0]
                    .split("|");
                } else {
                  that.center = that.dots[0][0];
                }
              }
            } else {
              that.center = res.data.data.lnglat.split("-")[0].split("|");
              that.location_center = res.data.data.lnglat
                .split("-")[0]
                .split("|");
            }
            console.log("dots", that.dots);
            console.log("lnglat", that.lnglat);
            that.schoolCenter = that.center;
          })
          .catch(function (res) {
            console.log("err", res);
            alert("查询失败，请检查网络");
          });
      } else {
        console.log("没有信息");
      }
    },
    // 起始点移动
    startBack() {

      let step = parseInt(this.startDotStep);
        if (this.lnglat[0].length > step) {
          let list = this.lnglat[0].slice(step);
          console.log(list)
          for (let i=0; i<step; i++) {
            list.push(this.lnglat[0][i]);
          }
          
          this.lnglat[0] = list;
          let r = list.map(x => {
            return x.split('|');
          })
          this.dots.splice(0, 1, r);
        }

        console.log(this.lnglat)

      },
      startForward() {
        let step = parseInt(this.startDotStep);
        console.log(this.dots)
        if (this.lnglat[0].length > step) {
          let list = this.lnglat[0].slice(0, this.lnglat[0].length - step);
          for (let i=this.lnglat[0].length - 1; i>this.lnglat[0].length - 1 - step; i--) {
            list.unshift(this.lnglat[0][i]);
          }
          this.lnglat[0] = list;
          console.log(this.lnglat)
         
          let r =list.map(x => {
            return x.split('|');
          })
          this.dots.splice(0, 1, r);
        }
      },
    // 获取附近三公里学区
    getNearschool() {
      let that = this;
      that.nearbySchoolList.length = 0;
      that.markerLists.length = 0;
      let currentMap = that.amapManager.getMap();
      that.$axios
        .post(that.$url_prefix + "school/getNearDots", {
          centerPoint: that.schoolCenter,
        })
        .then(function (res) {
          console.log("查询板块返回", res);
          if (res.data.data.length !== 0) {
            let j = 0;
            for (const alldots of res.data.data) {
              if (alldots.dots) {
                if (alldots.dots.indexOf("-") > -1) {
                  let lnglat = alldots.dots.split("-");
                  let dots = alldots.dots.split("-").map((x) => {
                    return x.split("|");
                  });
                  dots.push(dots[0]);

                  that.nearbySchoolList.push(dots);
                  that.schollLnglat.push(lnglat);
                } else {
                  let lnglat = JSON.parse(alldots.dots);
                  if (lnglat[lnglat.length - 1].length === 0) {
                    lnglat.pop();
                  }
                  let dots = JSON.parse(JSON.stringify(lnglat)).map((x) => {
                    for (let i = 0; i < x.length; i++) {
                      x[i] = x[i].split("|");
                    }
                    x.push(x[0]);
                    return x;
                  });
                  that.nearbySchoolList.push(dots);
                  that.schollLnglat.push(lnglat);
                }
              }
              that.$set(that.schollLnglat[j], "visible", false);
              // that.nearbySchoolList[j].visible = true;
              that.$set(that.nearbySchoolList[j], "visible", false);
              that.nearbySchoolList[
                j
              ].content = `<div style="background-color: #FF00FF; color: #FFFFFF; padding: 4px; border-radius: 4px;">${alldots.location_name}</div>`;
              let position = alldots.lnglat.split("-")[0].split("|");
              let marker = {
                position: position,
                content: `<div style="background-color: #FF00FF; color: #FFFFFF; padding: 4px; border-radius: 4px;">${alldots.location_name}</div>`,
                offset: new AMap.Pixel(-20, -15),
                zIndex: 120,
              };
              that.markerLists.push(marker);
              j++;
            }
          }
          console.log("查询板块返回", that.nearbySchoolList);
          console.log("查询板块返回", that.markerLists);
          console.log("查询板块返回", that.schollLnglat);
          that.getMarker = true;
        })
        .catch(function (res) {
          console.log("查询板块失败", res);
        });
    },
    //地图搜索的回调
    onSearchResult(pois) {
      if (pois.length > 0) {
        let { lng, lat } = pois[0];
        this.markers = pois;
        this.center = [lng, lat];
      }
    },

    //上传数据库
    upToDb() {
      let that = this;

      let obj = {};

      if (that.location_name.length === 0 || that.location_id.length === 0) {
        return;
      }

      let targetList = that.lnglat.filter((x) => x.length > 3);
      if (targetList.length > 0) {
        obj.dots = JSON.stringify(targetList);
      } else {
        obj.dots = "";
      }

      obj.id = that.location_id;
      obj.edit_dots_time=new Date().toLocaleString()
      let param = {
        db: that.locMap[that.$store.state.Counter.city],
        model: "edit",
        item: JSON.stringify(obj)

      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (want) {
          that.$router.push({
            path: "/IndexPage",
          });
        })
        .catch(function (res) {
          console.log("上传地段失败", res);
        });
    },

    // 一键恢复
    lnglatToDots() {
      let that = this;
      for (let i = 0; i < this.lnglat.length; i++) {
        if (this.lnglat[i].length === 0) {
          this.lnglat.splice(i, 1);
          this.dots.splice(i, 1);
          i--;
        }
      }
      if (this.lnglat.length === 0) {
        return;
      }
      let temp = JSON.parse(JSON.stringify(that.lnglat[0]));
      for (let i = 0; i < temp.length; i++) {
        temp[i] = temp[i].split("|");
      }
      that.dots[0].splice(0, that.dots[0].length, ...temp);
    },
    // 另起一个圈
    addCircle() {
      if (this.lnglat[0] && this.lnglat[0].length === 0) {
        return;
      }
      this.lnglat.unshift([]);
      this.dots.unshift([]);
      this.$message({
        type: "success",
        message: "另起一圈成功",
      });
      console.log("this.lnglat", this.lnglat);
      console.log("this.dots", this.dots);
    },
    // 切换编辑圈
    switchCircle() {
      for (let i = 0; i < this.lnglat.length; i++) {
        if (this.lnglat[i].length === 0) {
          this.lnglat.splice(i, 1);
          this.dots.splice(i, 1);
          i--;
        }
      }
      if (this.lnglat.length > 1) {
        this.lnglat.unshift(this.lnglat.pop());
        this.dots.unshift(this.dots.pop());
      }
      this.$message({
        type: "success",
        message: "切换编辑圈成功",
      });
    },

    districtSearch() {
      let that = this;
      if (that.district.length === 0) {
        return;
      }
      let currentMap = that.amapManager.getMap();
      let district = new AMap.DistrictSearch({
        // 返回行政区边界坐标等具体信息
        extensions: "all",
        // 设置查询行政区级别为 区
        level: "district",
      });
      district.search(that.district, function (status, result) {
        console.log("result", result);
        let bounds = result.districtList[0].boundaries;
        let polygons = [];
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            let polygon = new AMap.Polygon({
              map: currentMap,
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0,
              bubble: true,
              // fillColor: '#CCF3FF',
              strokeColor: "#CC66CC",
            });
            polygons.push(polygon);
          }
        }
      });
    },

    addPraise(e) {
      let that = this;
      let num = parseInt(that.praise_count1);
      if (num) {
        let obj = {
          id: that.location_id,
          praise_count: num,
        };

        let param = {
          db: that.locMap[that.$store.state.Counter.city],
          model: "edit",
          item: JSON.stringify(obj),
        };
        that.$axios
          .post(that.$url_prefix + "updateData", param)
          .then(function (want) {
            that.praise_count1 = "";
            e.target.blur();
            that.$message({
              type: "success",
              message: "修改成功",
            });
          })
          .catch(function (res) {
            that.$message.error("更新失败");
          });
      } else {
        that.$message.error("填写错误");
      }
    },

    drawLimitArea() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: that.imageLayerId,
            db: "AreaPlanModel",
          },
        })
        .then(function (res) {
          let plan = res.data.data;
          let currentMap = amapManager.getMap();

          that.imageLayer = new AMap.ImageLayer({
            url: plan.image,
            bounds: new AMap.Bounds(
              plan.southwest.split("|"),
              plan.northeast.split("|")
            ),
            zooms: [12, 18],
            opacity: 0.5,
            map: currentMap,
          });
        })
        .catch(function (res) {
          console.log("query fail", res);
          that.$message.error("查询失败, 请检查网络");
        });
    },
  },
};
</script>

<style scoped>
.realEstate {
  display: flex;
  width: 100%;
}

.realEstate .edit-area {
  text-align: center;
  width: 30%;
}

.realEstate #school_container {
  width: 70%;
  position: fixed;
  top: 0;
  left: 30%;
}
#school_container .query-box {
  position: absolute;
  left: 10px;
  z-index: 1;
  top: 70px;
}

#school_container .search-box {
  position: absolute;
  left: 0;
  top: 0;
  border: 1px solid black;
}

.imageBox {
  margin: 20px auto;
  display: flex;
  flex-wrap: wrap;
}

.imageBox .imageItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
}

img {
  height: 100px;
  width: 100px;
  vertical-align: bottom;
}

.up {
  margin-top: 20px;
  width: 150px;
  height: 50px;
  border-radius: 10px;
}

.adImg {
  height: 100px;
}

.line {
  margin-top: 20px;
  color: #ccc;
}

.normal {
  margin: 10px 0;
}

.white {
  height: 50px;
}

.salesmanList {
  display: flex;
  flex-wrap: wrap;
}

.salesman {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 20px;
}

.salesman img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/page/schoolDistrict.vue